export default __webpack_public_path__ + "static/media/add_product-stap_05.8d63a5e0.png";